var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{class:_vm.buttonStyle === false ? 'link link--is-button link--secondary save-configuration__link' : 'btn btn--primary btn--full-width save-configuration__button',on:{"click":_vm.showModal}},[_vm._v("Save configuration")]),_vm._v(" "),_c('SaveConfigurationModal',{ref:"saveConfigurationModal"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }